import { render, staticRenderFns } from "./CenterInfoBarChart.vue?vue&type=template&id=fb5ba0f4"
import script from "./CenterInfoBarChart.vue?vue&type=script&lang=ts"
export * from "./CenterInfoBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports